import { api } from "@/lib/http.ts";
import { type QueryKey, useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Hook for deleting messages with React Query mutation.
 * Automatically invalidates the message list query after successful deletion.
 */
export const useDeleteMessage = ({
  threadId,
  messageListQueryKey,
}: {
  threadId: number;
  messageListQueryKey: QueryKey;
}) => {
  const queryClient = useQueryClient();

  const { mutate: deleteMessages, isPending: isDeleting } = useMutation({
    mutationFn: async (messageId: number) => {
      await api.post(`/api/a/threads/${threadId}/messages/${messageId}/delete`, { messageId });
    },
    onSuccess: () => {
      // Invalidate and refetch the message list for this thread
      queryClient.invalidateQueries({
        queryKey: messageListQueryKey,
      });
    },
  });

  return { deleteMessages, isDeleting };
};
